import React from "react";
// Components
import { Field } from "components";
import { BaseInput } from "components/Common/Field/BaseInput";

export const InputPassword: React.FC<InputPasswordProps> = (props) => <BaseInput {...props} type="password" />;

export const FieldPassword: React.FC<FieldPasswordProps> = ({ error, inputProps, ...props }) => (
  <Field error={error} labelFor={inputProps.name} {...props}>
    <InputPassword hasError={!!error} {...inputProps} />
  </Field>
);
